import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconArrowUp: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = "#3E454D",
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5301 10.5301C19.3841 10.6761 19.192 10.7501 19 10.7501C18.808 10.7501 18.616 10.6771 18.47 10.5301L12.75 4.81017V21.0001C12.75 21.4141 12.414 21.7501 12 21.7501C11.586 21.7501 11.25 21.4141 11.25 21.0001V4.81115L5.53005 10.5311C5.23705 10.8241 4.76202 10.8241 4.46902 10.5311C4.17602 10.2381 4.17602 9.76309 4.46902 9.47009L11.469 2.47009C11.538 2.40109 11.6209 2.34622 11.7129 2.30822C11.8959 2.23222 12.1029 2.23222 12.2859 2.30822C12.3779 2.34622 12.4611 2.40109 12.5301 2.47009L19.5301 9.47009C19.8231 9.76309 19.8231 10.2371 19.5301 10.5301Z" fill={color} />
  </svg>

);

export default IconArrowUp;
